export enum ProfileSectionTypes {
  PROFILE = 'Personal info',
  CONTACT = 'Contact info',
  NPI = 'NPI & Licenses',
  SECURITY_AND_PRIVACY = 'Security & privacy',
  HEALTH_QUESTIONNAIRE = 'Health Questionnaire',
}

export enum ProviderProfileSectionTypes {
  ACCOUNT_INFO = 'Account info',
  PERSONAL_INFO = 'Personal info',
  CONTACT_INFO = 'Contact info',
  NPI = 'NPI & Licenses',
  CREDENTIALS_AND_CERTIFICATIONS = 'Credentials & certifications',
  SCHEDULE_AND_AVAILABILITY = 'Schedule & availability',
  BILLING_INFO = 'Billing services',
  LEGAL = 'Legal & Connected accounts',
}

export enum ProviderProfileSectionRoutes {
  ACCOUNT_INFO = 'account-info',
  PERSONAL_INFO = 'personal-info',
  CONTACT_INFO = 'contact-info',
  NPI = 'licenses',
  CREDENTIALS_AND_CERTIFICATIONS = 'credentials-and-certifications',
  SCHEDULE_AND_AVAILABILITY = 'schedule-and-availability',
  BILLING_INFO = 'billing-services',
  LEGAL = 'connected-accounts',
  SECURITY_AND_PRIVACY = 'security-and-privacy',
  MY_NOTIFICATIONS_SETTINGS = 'notifications-settings',
  APP_TOUR = 'app-tour',
}
